import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

const CardIntro = ({ data, long = false }) => {
  const { avatar, snippetIntro } = data;
  return (
    <div className={`intro ${long ? 'long' : ''}`}>
      {avatar && (
        <div className={`image ${long ? 'long' : ''}`}>
          <GatsbyImage alt="avatar" image={getImage(avatar)} />
        </div>
      )}
      <div className={`snippet ${long ? 'long' : ''}`}>{snippetIntro}</div>
    </div>
  );
};

CardIntro.propTypes = {
  data: PropTypes.object,
  long: PropTypes.bool,
};

export default CardIntro;
